import React from 'react';
import {Link} from "react-router-dom";
import ScrollAnimation from "react-animate-on-scroll";

const ServiceList = [
    {
        image: '/images/service/serviice-01.jpg',
        title: 'Social Media Marketing',
        description: 'We Create Quality Posts, Videos, Reels all with Researched Hashtags and Run the best Ads for promotion'
    },
    {
        image: '/images/service/serviice-02.jpg',
        title: 'Search Engine Marketing',
        description: 'We make sure to rank atleast one main keyword organially using SEO and List the Website over Google MyBusiness then Run the Ads beating up the Competition.'
    },
    {
        image: '/images/service/serviice-03.jpg',
        title: 'Customers Management',
        description: 'The Generated leads are directed to the Relationship Team who are expert influencers and convert Leads to make the purchase.'
    },
    {
        image: '/images/service/serviice-04.png',
        title: 'Cold Calling/E-Mails',
        description: 'This technique really works out just because we carry Databases containing Emails, Phones Details of about a billion people for any partiular niche.'
    }
]
const ServiceTwo = ({textAlign, cardStyle}) => {
    return (
        <div className="row row--15 service-wrapper">
              {ServiceList.map( (val , i) => (
                <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6 col-12" key={i}>
                    <ScrollAnimation 
                    animateIn="fadeInUp"
                    animateOut="fadeInOut"
                    animateOnce={true}>
                        <div className={`card-box ${cardStyle} ${textAlign}`}>
                            <div className="inner">
                                <div className="image">
                                    <Link to="#service">
                                        <img src={`${val.image}`} alt="card Images" />
                                    </Link>
                                </div>
                                <div className="content">
                                    <h4 className="title mb--20"><Link to="#service" dangerouslySetInnerHTML={{__html: val.title}}></Link></h4>
                                    <p className="description b1 color-gray mb--0" dangerouslySetInnerHTML={{__html: val.description}}></p>
                                    <Link className="btn-default btn-small btn-border" to="#service">Read More</Link>
                                </div>
                            </div>
                        </div>
                    </ScrollAnimation>
                </div>
            ))}
        </div>
    )
}
export default ServiceTwo;